import * as R from 'ramda';
import { Endpoints } from '../../../core/api/endpoints';
import { ApiReducer, makeApiReducer, makeApiAction, makeRsaaTypes } from '../../../core/api/rsaa';
import { addError, noLoadingNoError, addLoading, getLoading } from '../../../core/api/module';
import { ActionType } from '../../../core/redux/actionType';


const KEY_ACTION = ActionType.UnsetCreatedSurveyRequest;
const ACTIONS    = [
  ActionType.UnsetCreatedSurveyRequest,
  ActionType.UnsetCreatedSurveyResponse,
  ActionType.UnsetCreatedSurveyError,
];


type Payload = string;

type Meta = {
  projectId: number;
  participantId: number;
};


/**
 * Dispatch this action to add a dev plan item
 */
export const unsetCreatedSurveyAction = (
  projectId: number,
  participantId: number,
) => makeApiAction<Payload, Meta>({
  method:   'POST',
  endpoint: Endpoints.UnsetCreatedSurvey,
  headers:  { 'content-type': 'application/json' },
  body:     state => JSON.stringify({
    projectId:     projectId,
    participantId: participantId,
  }),
  types:    makeRsaaTypes<Payload, Meta>(ACTIONS, { projectId, participantId }),
  bailout:  state => !!getLoading(state, KEY_ACTION),
});


const reducer: ApiReducer<Payload, Meta> = (state, action, errorMsg, isLoading, payload) => {
  if (isLoading) {
    return addLoading(state, KEY_ACTION);
  }

  if (errorMsg) {
    return addError(state, KEY_ACTION, errorMsg);
  }

  const successState = noLoadingNoError(state, KEY_ACTION);

  return R.assocPath(['projectSummary', 'followupSurveyCreated'], false, successState);
};


export const unsetCreatedSurveyReducer = makeApiReducer<Payload, Meta>(ACTIONS, KEY_ACTION, reducer);
